import { CUSTOMER_TYPE, RECIPIENT_TYPES } from 'components/common/constants';
import { trimTextContent } from 'services/utils';

export default (newPaymentFormData) => {
  const baseModel = {
    type: CUSTOMER_TYPE[newPaymentFormData?.recipientType?.toUpperCase()]?.toUpperCase(),
    internalWalletNumber: newPaymentFormData?.internalWalletNumber
  };

  if (newPaymentFormData?.recipientType === RECIPIENT_TYPES.INDIVIDUAL) {
    return {
      ...baseModel,
      firstName: trimTextContent(newPaymentFormData?.firstName),
      lastName: trimTextContent(newPaymentFormData?.lastName)
    };
  }

  if (newPaymentFormData?.recipientType === RECIPIENT_TYPES.COMPANY) {
    return {
      ...baseModel,
      companyName: trimTextContent(newPaymentFormData?.companyName)
    };
  }

  return baseModel;
};
